module.exports = __webpack_public_path__ + "img/thank-you.5aedbd39.svg";